import React, { useEffect, useState } from 'react';
import SelectableFilter from 'Components/HorseRacing/SelectableFilter';
import { format } from 'date-fns';
import queryString from 'query-string';
import History from 'Store/history';
import { getReportedJockeys, getSuspendedJockeys } from 'Store/actions/jockeyActions';


const ReportedSuspendedJockeys = props => {
  const filterData = [
    { id: '1', descriptionAbbr: 'Raporlu', icon: null },
    { id: '2', descriptionAbbr: 'Cezalı', icon: null },
  ];
  const tableHeaders = ['Jokey', 'Başlangıç Tarihi', 'Bitiş Tarihi'];

  const [selectedSort, setSelectedSort] = useState(null);
  const [tableData, setTableData] = useState({});

  useEffect(() => {
    if (selectedSort?.descriptionAbbr === 'Raporlu') {
      History.push({
        search: '?selectedTab=reported'
      });
      getReportedJockeys().then(res => {
        setTableData(res.data);
      } );
    } else if (selectedSort?.descriptionAbbr === 'Cezalı') {
      History.push({
        search: '?selectedTab=suspended'
      });
      getSuspendedJockeys().then(res => {
        setTableData(res.data);
      } );
    }
  }, [selectedSort]);

  useEffect(() => {
    const selectionFromQueryString = queryString.parse(History?.location?.search).selectedTab || queryString.parse(History?.location?.search).selectedtab;
    if (selectionFromQueryString) {
      setSelectedSort(selectionFromQueryString === 'suspended' ? filterData[1] : filterData[0]);
    }
  }, []);

  return (
    <div className="tjk-layout">
      { /* <BreadCrumb/>*/ }
      <div className="tjk-layout-content">
        { /*<TjkSideNavigation/>*/ }
        <div className="content-wrapper">
          <div className="page page--reported-suspended-jockeys">
            <div className="information-box">
              <div className="information-box__head">
                <div className="information-box__head__title">Raporlu & Cezalı Jokeyler</div>
              </div>
              <div className="information-box-content">
                <SelectableFilter data={ filterData } selectedId={ selectedSort?.id } onSelect={ item => {
                  setSelectedSort(item);
                } } className="material"/>
                {
                  tableData?.body?.d
                  && (<table className="information-box-content__table">
                    <tr>
                      {
                        tableHeaders.map(title => {
                          return (<th key={ title }>{ title }</th>);
                        })
                      }
                    </tr>
                    { tableData?.body?.d && (tableData?.body?.d.map((jockey, index) => (
                      <tr key={ index }>
                        <td>{ jockey.name }</td>
                        <td>{ format(new Date(jockey.startDate), 'dd.MM.yyyy') }</td>
                        <td>{ format(new Date(jockey.endDate), 'dd.MM.yyyy') }</td>
                      </tr>
                    ))) }
                  </table>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportedSuspendedJockeys;
